export { default as Img200 } from './processed/200/PANS-LABYRINTH.jpg';
export { default as Img400 } from './processed/400/PANS-LABYRINTH.jpg';
export { default as Imgthumb } from './processed/thumb/PANS-LABYRINTH.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/PANS-LABYRINTH.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/PANS-LABYRINTH.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      38,
      157,
      175
    ],
    "_population": 14,
    "_hsl": [
      0.5218978102189781,
      0.6431924882629108,
      0.4176470588235294
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      228,
      188
    ],
    "_population": 1,
    "_hsl": [
      0.1388888888888889,
      0.558139534883721,
      0.8313725490196079
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      19,
      92,
      92
    ],
    "_population": 41,
    "_hsl": [
      0.5,
      0.6576576576576576,
      0.21764705882352942
    ]
  },
  "Muted": {
    "_rgb": [
      101,
      135,
      153
    ],
    "_population": 52,
    "_hsl": [
      0.5576923076923076,
      0.2047244094488189,
      0.4980392156862745
    ]
  },
  "LightMuted": {
    "_rgb": [
      210,
      180,
      176
    ],
    "_population": 370,
    "_hsl": [
      0.019607843137254975,
      0.2741935483870967,
      0.7568627450980392
    ]
  },
  "DarkMuted": {
    "_rgb": [
      53,
      73,
      87
    ],
    "_population": 88,
    "_hsl": [
      0.5686274509803922,
      0.24285714285714283,
      0.27450980392156865
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/PANS-LABYRINTH.js